import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref } from 'vue'
import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'

import InsuranceView from '@/components/InsuranceView.vue'

import { useVehiclesStore } from '@/store/vehicles'
import { TripFull } from '@/models/trip'
import { useTripsStore } from '@/store/trips'


export default /*@__PURE__*/_defineComponent({
  __name: 'InsurancesSection',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props
const loading = ref(false)
const vehiclesStore = useVehiclesStore()
const tripStore = useTripsStore()

const carProfile = computed(
  () => vehiclesStore.vehiclesDetails[props.trip.car_profile_id]
)

const carProfileInsurance = computed(() => {
  return vehiclesStore.vehiclesDetails[props.trip.car_profile_id]?.data
    ?.insurance_request
})

const isLoading = computed(
  () =>
    vehiclesStore.vehiclesDetails[props.trip.car_profile_id]?.isLoading ?? false
)

const error = computed(
  () => vehiclesStore.vehiclesDetails[props.trip.car_profile_id]?.error
)

const showCancellationBtn = computed(() => {
  if (props.trip.cancel_policy_script === 'approved') return false
  if (!carProfileInsurance.value) return false
  if (!props.trip.innerInsurance) return false

  return true
})

const getVehicleDetails = () => {
  vehiclesStore.getVehicleDetails(props.trip.car_profile_id)
}

const cancelInsurance = async () => {
  try {
    loading.value = true
    await vehiclesStore.cancelInsurance(
      props.trip?.innerInsurance?.policy_number ?? ''
    )
    await tripStore.getTripDetails(props.trip.id)
  } catch (error) {
    error
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  if (!carProfile.value && !isLoading.value) getVehicleDetails()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    (error.value)
      ? (_openBlock(), _createBlock(CommonError, {
          key: 0,
          errorMessage: error.value,
          onRetryPress: getVehicleDetails
        }, null, 8, ["errorMessage"]))
      : (isLoading.value)
        ? (_openBlock(), _createBlock(Loader, { key: 1 }))
        : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      (showCancellationBtn.value)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            style: {"margin-top":"20px","text-align":"right"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "danger",
                onClick: cancelInsurance,
                loading: loading.value,
                disabled: loading.value
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" Cancel Insurance ")
                ])),
                _: 1,
                __: [0]
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(InsuranceView, {
        insurance: carProfileInsurance.value,
        "is-fields-editable": false
      }, null, 8, ["insurance"])
    ], 512), [
      [_vShow, !isLoading.value && !error.value]
    ])
  ]))
}
}

})